module.exports = __webpack_public_path__ + "static/media/291856.02bea02c.png";